import React from "react";

// Components
import Button from "components/Button";

// Libs
import { toast } from "react-toastify";

// Services
import DashboardService from "services/dashboard";

// Context
import { useGeneralProvider } from "contexts/general";

// Imgs
import CloseIconSvg from "assets/close-icon.svg";

import {
  BackDrop,
  Container,
  ImageWrapper,
  CloseIcon,
  Header,
  HeaderText,
  FooterContainer,
} from "./styles";

function ModalConfirmUpdate({
  setShowModal,
  companyId,
  userId,
  handleCleanFilters,
}) {
  const { setLoading, globalUser } = useGeneralProvider();
  const userPassService = new DashboardService(globalUser);

  const handleUpdateCompanyUser = () => {
    setLoading(true);

    userPassService
      .updateCompanyUserStatus({
        companyId: companyId,
        userId: userId,
        userStatus: 1,
      })
      .then(() => {
        toast.success("Usuário inativado com sucesso!");
        handleCleanFilters();
        setShowModal(false);
      })
      .catch((err) => {
        setLoading(false);

        if (err?.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Falha ao inativar usuário");
        }
      });
  };

  return (
    <BackDrop>
      <Container>
        <Header>
          <ImageWrapper />
          <HeaderText>Deseja inativar este usuário?</HeaderText>
          <ImageWrapper onClick={() => setShowModal(false)}>
            <CloseIcon src={CloseIconSvg} />
          </ImageWrapper>
        </Header>
        <FooterContainer>
          <Button label="Confirmar" onClick={handleUpdateCompanyUser} />
        </FooterContainer>
      </Container>
    </BackDrop>
  );
}

export default ModalConfirmUpdate;
